import React from 'react';
import Typography from '@mui/material/Typography';
import moment from 'moment';

export default function Copyright(props: any) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      Copyright © PA.ID Backstage
      {' - ' + moment().format('YYYY')}
    </Typography>
  );
}
